(function () {
  const STORAGE_KEY = "rv_handles_v1";

  function readHandles() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      const arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr : [];
    } catch (_) {
      return [];
    }
  }

  function writeHandles(arr) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(arr));
    } catch (_) {}
  }

  // Call on product pages: adds current product handle to storage
  function trackCurrentProduct() {
    const el = document.querySelector("[data-product-handle]");
    if (!el) return;

    const handle = (el.getAttribute("data-product-handle") || "").trim();
    if (!handle) return;

    const list = readHandles().filter(Boolean);

    // remove existing
    const filtered = list.filter(h => h !== handle);
    // unshift newest
    filtered.unshift(handle);

    // keep max 20 (safe with all_products)
    writeHandles(filtered.slice(0, 20));
  }

  async function loadRecentlyViewedSections() {
    const blocks = document.querySelectorAll("[data-recently-viewed]");
    if (!blocks.length) return;

    const list = readHandles();
    if (!list.length) {
      blocks.forEach(b => (b.hidden = true));
      return;
    }

    for (const block of blocks) {
      const limit = Number(block.getAttribute("data-limit") || 8);
      const handles = list.slice(0, limit);

      if (!handles.length) {
        block.hidden = true;
        continue;
      }

      const sectionRoute = block.getAttribute("data-section-route") || "/";
      const sectionHandle = block.getAttribute("data-section-handle") || "recently-viewed";

      const url = new URL(sectionRoute, window.location.origin);
      url.searchParams.set("section_id", sectionHandle);
      url.searchParams.set("handles", handles.join(","));

      try {
        const res = await fetch(url.toString(), { credentials: "same-origin" });
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, "text/html");
        const el = doc.querySelector("[data-recently-viewed]");

        // Shopify returns section HTML as a string; inject it
        // Replace the whole block content:
        block.innerHTML = el.innerHTML;

        // If your theme wraps section HTML, you may need to extract inner part.
        block.hidden = false;
      } catch (e) {
        // fail silently
      }
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    trackCurrentProduct();
    loadRecentlyViewedSections();
  });
})();
